<!--<pre>{{ detailSubject|async|json }}</pre>-->
<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="scopeSubject.value"
  [title]="'Cakupan'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.SCOPE"
/>

<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="distributorDetailSubject.value"
  [title]="'Detail Distributor'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.DISTRIBUTOR_DETAIL"
/>

<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="ownerSubject.value"
  [title]="'Pemilik Usaha'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.OWNER"
  [type]="EnumCardVerificationForm.KTP"
/>

<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="managerSubject.value"
  [title]="'Pengelola Usaha'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.MANAGER"
  [type]="EnumCardVerificationForm.KTP"
/>

<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="creditCeilingSubject.value"
  [title]="'Plafon Kredit'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.CREDIT_CEILING_GRANTED"
/>

<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="creditBillingSubject.value"
  [title]="'Penagihan Kredit'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.CREDIT_BILLING"
/>

<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="dokumenPendaftaranSubject.value"
  [title]="'Dokumen Pendaftaran'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.DOCUMENT"
  [type]="EnumCardVerificationForm.DOCUMENT"
/>
